const Login = () => import('Views/login/login-new-ui');
const Register = () => import('Views/login/register-new-ui');
const ForgetPassword = () => import('Views/login/forget-password');

export default[
  { path: '/web/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/forget-password', name: 'forgetPassword', component: ForgetPassword },
];



// WEBPACK FOOTER //
// ./src/router/login.js